import React, { useState, useEffect, Fragment } from "react";
import {
    Card, CardBody, Row, CardTitle, UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Button, Modal, ModalHeader, ModalBody
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import {
    gAPI_GetEvent_By_Place_Predict,
    gAPI_GetEvent_By_Miles_Predict,
    gAPI_GetEvent_By_Country_Predict,
    dAPI_Delete_Widget
} from '../../../../../constants/APIs';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { EventSettingForm } from './EventSettingForm';
let id = "";
export function EventList({ eventData, LoadData, propertyId, layoutItem }) {
    const [edit, setEdit] = useState(false);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [getEventData, setGetEventData] = useState([]);
    useEffect(() => {
        if (eventData.id !== undefined) {
            let arratsetting = JSON.parse(eventData.settings);
            var category = arratsetting.Category.join().toLowerCase();
            var miles = arratsetting.Miles;
            var place = arratsetting.Places;
            var country = "";
            console.log(category);
            console.log(place);
            // arratsetting.map((item, i) => {
            //     category = item.Category.join().toLowerCase();
            //     miles = item.Miles;
            //     place = item.Places;
            // })
            var placeId = "";
            place.map((item, index) => {
                placeId = item.Id;
                country = item.Country
            })
            console.log(country, category, miles);
            var fromDate = new Date().toISOString().slice(0, 10)
            let d = new Date();
            let toDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + (d.getDate() + 10);

            console.log(moment(fromDate).format('YYYY-MM-DD'), moment(toDate).format('YYYY-MM-DD'));
            if (country !== "" && category !== "" && miles !== "") {
                AxiosAPI({
                    methhod: 'get',
                    url: `${gAPI_GetEvent_By_Country_Predict}?country=${country}&category=${category}&active.gte=${moment(fromDate).format('YYYY-MM-DD')}&active.lte=${moment(toDate).format('YYYY-MM-DD')}`,
                }).then(
                    (res) => {
                        // let data = { 'data': res.data.result, id: '' };
                        // data.id = item.id;
                        // console.log(data);
                        setGetEventData(res.data.results);
                        console.log(res.data.results);

                    },
                    (error) => {
                        // this.setState({ loading: false, error, isLoading: false });
                    }
                );
            }
        }

    }, [eventData.id]);
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const onRemoveItem = (widgetid) => {
        let updateData = {
            id: widgetid
        }
        console.log(updateData);
        AxiosAPI({
            method: 'delete',
            url: `${dAPI_Delete_Widget}/${widgetid}`,
            data: updateData,
        })
            .then(result => {
                LoadData()
            }
            )
            .catch(err => {
                console.log('err', err);
            });
    };
    const onEditItem = (widgetid) => {
        setEdit(true);
        id = widgetid;
    };
    const generateDeleteButton = () => {
        return (
            <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                    <span role="img" aria-label="warning">
                        ⚠️
                    </span>
                    This Event will be deleted!
                </ModalHeader>
                <ModalBody>
                    <Button
                        color="danger"
                        onClick={() => onRemoveItem(eventData.id)}
                        size="xs"
                    >
                        Delete
                    </Button>
                    <Button
                        className="ml-2"
                        color="dark"
                        outline
                        size="xs"
                        onClick={toggle}
                    >
                        Cancel
                    </Button>
                </ModalBody>
            </Modal>
        );
    };
    return (
        <Fragment>
            <div
            // style={{
            //     display: "flex",
            //     flexDirection: "column",
            //     overflow: "hidden",
            //     maxHeight: "-webkit-fill-available"
            // }}
            >
                {edit ? (
                    <EventSettingForm
                        propertyId={propertyId}
                        layoutItem={layoutItem}
                        LoadData={LoadData}
                        setIsEdit={setEdit}
                        eventData={eventData}
                        eventId={id}></EventSettingForm>)
                    :
                    (<div>
                        <div className="position-absolute card-top-buttons mb-5 p-0">
                            <UncontrolledDropdown>
                                <DropdownToggle color="" className="btn btn-header-light icon-button">
                                    <i className="simple-icon-options" />
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem onClick={() => onEditItem(eventData.id)}>
                                        <i className="glyph-icon simple-icon-pencil" /> Edit Event
                                    </DropdownItem>
                                    <DropdownItem onClick={toggle}>
                                        <i className="glyph-icon simple-icon-trash" /> Delete Event
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                        <div>
                            <div className="dashboard-list-with-user">
                                {getEventData !== undefined && getEventData.map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className="d-flex flex-row mb-3 pb-3 border-bottom"
                                        >
                                            <div className="pl-3 pr-2">
                                                <NavLink to={`#`}>
                                                    <p className="font-weight-medium mb-0">{item.title}</p>
                                                    <p className="text-muted mb-0 text-small">
                                                        {item.description}

                                                    </p>
                                                    <p className="text-muted mb-0 text-small">
                                                        {moment(item.start).format(
                                                            'DD/MM/YYYY h:mm a'
                                                        )} -
                                                        {moment(item.end).format(
                                                            'DD/MM/YYYY h:mm a'
                                                        )}
                                                    </p>
                                                </NavLink>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>)}

                {generateDeleteButton()}
            </div>

        </Fragment>
    );
}
